module.exports = "<div class=\"ui-g\">\n  <div class=\"ui-g-12\">\n    <img src=\"assets/fsm.png\">\n  </div>\n</div>\n"